const ageMap = new Map<number, string>([
  [0, 'Birth'],
  [182, '6mo'],
  [365, '12mo'],
  [548, '18mo'],
  [730, '24mo'],
  [912, '30mo'],
  [1095, '36mo'],
]);

export function formatAge(age?: number): string {
  if (!age && typeof age !== 'number') return '';
  return ageMap.get(age) ?? `${age} days`;
}
